import {Module} from '@mamdev/cad.static-next-lib';
import Viewport from '../../ts/services/viewport';

export default class Sement extends Module {
  // Init. from DOM.
  static attachTo(root: HTMLElement): Sement {
    return new Sement(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'sement';
  }

  // Start the module.
  start() {
    try {
      if (Viewport.isMobile() && window.location.hash === '#scroll') {
        this.scrollViewportToLetterBox();

        // remove hash from URL
        if ('replaceState' in window.history) {
          window.history.replaceState('', document.title, window.location.pathname + window.location.search);
        } else {
          window.location.hash = '';
        }
      }
    } catch (e) {
      this.logUnknownError(e);
    }
  }

  scrollViewportToLetterBox() {
    const letterBox = document.getElementsByClassName('h2')[0];

    Viewport.scrollViewPortTo(letterBox, 55);
  }
}
